module.exports = __webpack_public_path__ + "img/文本图形3.dc0f65d7.svg";